import PropTypes from "prop-types";
import React from "react";
import Box from "@mui/material/Box";
import TimerIcon from "@mui/icons-material/Timer";
import MDBox from "../MDBox";
import { formatDuration } from "../../utils/date.js";

function QuestionResult({ valid, question, answer, result, start, end, index }) {
  return (
    <MDBox
      flex={1}
      display="flex"
      alignItems="baseline"
      justifyContent="flex-start"
      flexWrap="wrap"
      color={valid ? "success" : "error"}
    >
      <Box sx={{ width: 30, textAlign: "right", mr: 1 }}>{index + 1}.</Box>
      <Box sx={{ flex: 1, display: "flex", alignItems: "baseline" }}>
        <Box sx={{ whiteSpace: "nowrap" }}>{question}</Box>
        <Box
          sx={{
            fontSize: "1.2em",
            ml: 1,
            textDecoration: valid ? undefined : "line-through",
          }}
        >
          {answer}
        </Box>
        {!valid && (
          <MDBox
            sx={{
              fontSize: "1.2em",
              ml: 1,
            }}
            color="success"
          >
            {result}
          </MDBox>
        )}
      </Box>
      {start && end && (
        <MDBox sx={{ ml: 2, color: "#999" }}>
          (<TimerIcon />{" "}
          {formatDuration(
            new Date(end.replace(" ", "T")).getTime() - new Date(start.replace(" ", "T")).getTime(),
            "hh:mm:ss.sss"
          )}
          )
        </MDBox>
      )}
    </MDBox>
  );
}

QuestionResult.propTypes = {
  valid: PropTypes.bool,
  question: PropTypes.any,
  answer: PropTypes.any,
  result: PropTypes.any,
  start: PropTypes.string,
  end: PropTypes.string,
  index: PropTypes.number,
};

export default QuestionResult;
